import React from "react";
import { Link, useLocation } from "react-router-dom";

const TABS = [
  { to: "/escape", label: "The Escape", sub: "2026 • New Orleans", color: "#6EE6E6" },
  { to: "/europe", label: "The Europe Experience", sub: "2027 • Europe", color: "#84FE2A" },
  { to: "/getaway", label: "The Getaway", sub: "2027 • Caribbean", color: "#F2C04C" },
];

const idFor = (to) => (to === "/getaway" ? "caribbean" : to === "/europe" ? "europe" : "escape");

const CruiseSwitch = ({ className = "" }) => {
  const { pathname } = useLocation();
  const current = pathname.length > 1 ? pathname.replace(/\/$/, "") : pathname;
  return (
    <div
      data-testid="cruise-switch"
      className={`inline-flex items-center gap-1 p-1 bg-black/50 border border-white/15 rounded-full backdrop-blur-sm ${className}`}
    >
      {TABS.map((t) => {
        const active = current === t.to;
        return (
          <Link
            key={t.to}
            to={t.to}
            data-testid={`cruise-tab-${idFor(t.to)}`}
            style={active ? undefined : { color: t.color }}
            className={`flex flex-col leading-none px-3 sm:px-3.5 py-1.5 rounded-full font-cond uppercase tracking-widest transition-colors ${
              active
                ? "bg-[#E50914] text-white"
                : "hover:bg-white/10"
            }`}
          >
            <span className="text-[10px] sm:text-[11px] font-semibold">{t.label}</span>
            <span className="text-[8px] sm:text-[9px] opacity-80 tracking-wide mt-0.5">{t.sub}</span>
          </Link>
        );
      })}
    </div>
  );
};

export default CruiseSwitch;
